import { isLoggedIn } from '@/state/Authentication'
import { cartExpired, refreshStoredCart } from '@/state/Cart'
import store from '@/store/store'
import { getCookie } from 'tiny-cookie'
import { fetchConfigCatFlags } from '@/helpers/ConfigCat'

export function initializeStores() {
  const hasSessionCookie = getCookie('session_expires')
  if (isLoggedIn() && !hasSessionCookie) {
    // The session has expired. Clear all storage, but stay on the current URL.
    store.dispatch('clearAll')
  } else {
    initializeFlags()
    initializeCartStore()
    initializeMemberStore()
  }
}

async function initializeFlags(): Promise<void> {
  const flags = await fetchConfigCatFlags()
  store.commit('setFlags', flags)
}

/**
 * Removes any known carts that have expired, are empty, or not pending (purchased/deleted elsewhere).
 * Seeds a Stripe wallet payment to check if digital wallets are supported before getting to checkout.
 */
function initializeCartStore(): void {
  if (cartExpired()) {
    store.dispatch('Cart/clearAll')
  } else if (store.getters['Cart/cart']) {
    // Reload the cart, which also confirms it is still valid.
    refreshStoredCart()
  }
}

/**
 * Initializes the members store in case of external authentication (MoS Boston).
 */
function initializeMemberStore() {
  const hasSessionCookie = getCookie('session_expires')
  const identity = store.getters['Member/identity']

  if (hasSessionCookie && !identity) {
    store.dispatch('Member/load')
  }
}
